// IMPORT JOB TO SCREENING ******************************************************
// pathname: /api/jobs/import
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi/useSwrMutationApi';
import { ApiSchemaScreening } from '@type/api/apiUtilityFnScreening';
import { screeningBaseURL } from '@utils/data-fetching/utils';

interface UseSwrImportJobProps {
  onSuccess?: (response: ApiSchemaScreening<'Job.JobOutput'>) => void | Promise<void>;
  onError?: (err: unknown) => void;
}

/**
 * @description SWR Mutation: Import a job to the screening backend.
 * @param props - { UseSwrImportJobProps } - Configuration with optional onSuccess and onError callbacks.
 */
export const useSwrImportJob = (props?: UseSwrImportJobProps) => {
  const { onSuccess, onError } = props ?? {};

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<
    ApiSchemaScreening<'Job.JobOutput'>,
    ApiSchemaScreening<'Job.JobImportInput'>
  >({
    url: '/api/jobs/import',
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      baseUrl: screeningBaseURL, // Use screening backend base URL
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess: (response) => { if (onSuccess) { void onSuccess(response); } },
      onError: (err) => { if (onError) onError(err); },
    },
    toastsOptions: {
      showErrorToast: true,
      showSuccessToast: false,
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
